import type {
  IErrorResponse,
  SignInVerifyOTPRequest,
  SignInVerifyOTPResponse,
} from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { urls } from '@/statics';
import { api } from '@/utils';

const useSignInVerifyOtp = (): UseMutationResult<
  SignInVerifyOTPResponse,
  IErrorResponse,
  SignInVerifyOTPRequest
> => {
  return useMutation({
    mutationFn: (data) => api.post(urls.signInVerifyOtp, data),
  });
};

export default useSignInVerifyOtp;
